import styled from 'styled-components';
import { PlaceholderText } from 'components/styles';
import { Translate } from 'hooks/use-translation';

export const placeholderForEmpty = '\u2014';

export const Placeholder = styled.div`
  ${PlaceholderText};
`;

export const renderPlaceholderForMultipleValues = (translate: Translate) => {
  return translate('bulk_editor.placeholder.multiple_values');
};

export const emptyValueFormatter = ({ value }) =>
  value != null ? value : placeholderForEmpty;
